export enum DATE_FORMAT_LIST {
  DATE_MONTH_SHORT = 'D MMM',
  DATE_MONTH = 'D MMMM',
  DAY_MONTH_FULL = 'DD MMMM',
  YEAR_FULL_DATE = 'YYYY-MM-DD',
  MONTH = 'MM',
  DAY = 'D',
  LONG_DAY = 'DD',
  FULL_DATE = 'DD.MM.YYYY',
  FULL_DATE_DATE_FNS = 'dd.MM.yyyy',
  FULL_DATE_SHORT_YEAR = 'DD.MM.YY',
  MONTH_STAND_ALONE = 'MMMM',
  FULL_DATE_WITH_MONTH_STAND_ALONE = 'DD.MM.YYYY',
  DAY_MONTH_WEEK_DAY = 'D MMM dd',
  DAY_MONTH_WEEK_DAY_SEPARATE = 'D MMM, dd',
  DAY_MONTH_YEAR_WEEKDAY = 'D MMMM YYYY, ddd',
  DAY_MONTH_YEAR_WEEKDAY_SHORT = 'D MMMM YYYY, dd',
  FIRST_DAY_OF_MONTH = 'YYYY/M/01',
  CALENDAR_RENDER = 'YYYY/M/DD',
  LONGER_DATE = 'd MMMM YYYY, dddd',
  TIME = 'HH:mm',
  FULL_DATE_BEKET = 'D MMMM, dd',
  FULL_DATE_AVIA = 'D MMM, dd',
}

export const monthsShort = [
  'янв',
  'фев',
  'мар',
  'апр',
  'май',
  'июн',
  'июл',
  'авг',
  'сен',
  'окт',
  'ноя',
  'дек',
]
